import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SiteLayoutComponent } from 'src/app/Layout/site-layout/site-layout.component';
import { ChangePasswordModel } from 'src/Models/ChangePasswordModel';
import { FilterModel } from 'src/Models/filterModel';
import { UserModel } from 'src/Models/usersModel';
import { UsersService } from 'src/Services/users.service';
import { CheckAuth } from 'src/Services/utility.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-create-password',
  templateUrl: './create-password.component.html',
  styleUrls: ['./create-password.component.css']
})
export class CreatePasswordComponent implements OnInit {

  userModel = new UserModel();
  appModel: any;
  tokenKey: string = '';
  loginForm: FormGroup;
  filterModel = new FilterModel();
  userId: number = 0;
  changePasswordModel = new ChangePasswordModel();

  constructor(private readonly router: Router,
    private readonly checkAuth: CheckAuth,
    private readonly _fb: FormBuilder,
    private readonly toastr: ToastrService,
    private readonly usersService: UsersService,
    private readonly titleService: Title,
    private readonly siteLayoutComponent: SiteLayoutComponent,
    private sessionStorageService: SessionStorageService
  ) {
    sessionStorage.removeItem('tokenValue');
    sessionStorage.removeItem('appStartTime');
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    sessionStorage.removeItem('isAdminOpen');
    sessionStorage.removeItem('AdminUserId');
    sessionStorage.removeItem('StateSetupManageRedirection');
    this.titleService.setTitle('Create Password | JSi360');
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.loginForm = this._fb.group({
      userid: 0,
      newpassword: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]]
    })

    this.userId = +sessionStorage.getItem('UserId');
    if (!this.userId) {
      this.router.navigate(['/Login']);
    }
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  updatePassword(loginForm) {

    this.changePasswordModel = loginForm.value;
    if (loginForm.value["newpassword"] == "") {
      this.showMessage('Please enter new password', 'Error', 'error');
      return;
    }
    if (loginForm.value["confirmPassword"] == "") {
      this.showMessage('Please enter confirm password', 'Error', 'error');
      return;
    }

    if (loginForm.value["confirmPassword"] != loginForm.value["newpassword"]) {
      this.showMessage('Confirm password not match', 'Error', 'error');
      return;
    }

    this.usersService.ChangePassword('null', this.changePasswordModel).subscribe(
      data => {
        if (data['status'] == 'Success') {
          if (data['id'] > 0) {
            this.showMessage('Password created successfully', 'Success', 'success');
            this.siteLayoutComponent.Logout();
            this.router.navigate(['/login']);
          }
        }
      },
      error => {

      }
    );
  }
}

